import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';
export const StyledIndustries = styled.div`
  padding-bottom: 36px;
  scroll-margin-top: 130px;
  .title {
    margin-bottom: 32px;
  }
  .slick-dots {
    bottom: -30px;
  }
  .slick-dots li button::before {
    color: #d1d1d1 !important;
    opacity: 1 !important;
  }
  .slick-dots li.slick-active button::before {
    opacity: 1 !important;
    color: #f58220 !important;
  }
  .slick-dots li button::before {
    font-size: 12px;
  }
  .serviceIndustries-items {
    background: #f4f4f4;
    border-radius: 8px;
    overflow: hidden;
    margin: 0 10px !important;
    .industries-items-textBox {
      padding: 32px;
      min-height: 280px;
      b {
        font-family: 'Rubik', sans-serif;
        font-size: 24px;
        display: block;
        font-weight: 500;
        margin-bottom: 10px;
        line-height: 1.2;
      }
      ul {
        padding-left: 15px;
        margin-bottom: 0px;
        li {
          padding: 4px 0px;
          line-height: 1.2;
        }
      }
      @media ${DEVICES.laptop} {
        padding: 32px;
        b {
          font-size: 24px;
        }
        ul {
          li {
            font-size: 16px;
          }
        }
      }
      @media ${DEVICES.tablet} {
        font-size: 20px;
        b {
          font-size: 24px;
        }
        ul {
          li {
            font-size: 16px;
          }
        }
      }
      @media ${DEVICES.mobile} {
        font-size: 20px;
        b {
          font-size: 24px;
        }
        ul {
          li {
            font-size: 16px;
          }
        }
      }
      @media ${DEVICES.sMobile} {
        padding: 16px;
        min-height: 230px;
        b {
          font-size: 14px;
        }
        ul {
          li {
            font-size: 12px;
          }
        }
      }
    }
  }
`;
